import { Link } from "react-router-dom";

const CakeBanner = () => {
  return (
    <div
      className="bg-cover h-[37vh] xl:h-screen bg-no-repeat bg-center pt-8 pb-20 px-10 relative"
      style={{
        backgroundImage: ` url(${`/images/tirupati_cooking_classes.jpg`})`,
      }}
    ></div>
  );
};

export default CakeBanner;
